import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Lock } from 'lucide-react';
export function PricingSection() {
  return <section className="bg-charcoal text-cream py-20 px-4 relative" data-id="element-78">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-80">
          <p className="text-xl md:text-2xl text-cream/80 mb-6" data-id="element-81">
            No vas a pagar{' '}
            <span className="line-through text-gold/60" data-id="element-82">$408</span>. Ni siquiera
            la mitad.
          </p>

          <p className="text-lg md:text-xl text-cream/90 mb-12 max-w-2xl mx-auto" data-id="element-83">
            Quiero que este blueprint llegue a cada familia latina que quiere
            honrar a Dios con su trabajo.
          </p>

          <div className="mb-12" data-id="element-84">
            <p className="text-lg md:text-xl text-cream/80 max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-85">
              Como estamos en fase de lanzamiento{' '}
              <span className="text-gold font-semibold" data-id="element-86">'Beta'</span> para los
              primeros 50 fundadores de la comunidad, no pagarás ni siquiera los{' '}
              <span className="line-through text-gold/60" data-id="element-87">$37</span> que costará
              el blueprint la próxima semana.
            </p>
            <p className="text-gold font-bold tracking-widest uppercase text-sm mb-4" data-id="element-88">
              HOY ACCEDES POR SOLO:
            </p>
            <div className="text-7xl md:text-8xl font-serif text-gold drop-shadow-lg mb-4" data-id="element-89">
              $6.36{' '}
              <span className="text-3xl md:text-4xl text-gold/80" data-id="element-90">USD</span>
            </div>
            <p className="text-cream/70 italic text-lg mb-2" data-id="element-91">
              Queremos tus testimonios, no tu dinero.
            </p>
            <p className="text-cream/60 italic" data-id="element-92">
              (Pago único. Acceso inmediato para toda la vida).
            </p>
          </div>

          <div id="pricing-cta" className="flex flex-col items-center gap-6" data-id="element-93">
            <Button href="https://shop.app/checkout/62094770273/cn/hWN9kHyJlXsS2alIrbJV9vwA/en-us/shoppay?_cs=3.AMPS&_r=AQAB2OxUPl4wBBS1Sj72NAA81cgSqmm22BqrGplKzl3mUKE&authorization=MHJOTXI3b2tTTndXRk5WeWE2bmRkWnJvMXE0aUo1QVhiM2lRRE9wd21kT1RNWDVwcnVUeEs5N0J4MDg0djRTb2JveGpTaG1DRDdrQ1lUMGV0YUUxVGxpeHk1d21hekFVeDFzVU5icDJLbFdrT3NqN0EzL1RFN0ZRdG1CNXJ5aXdHTFhaTVBiWmNvWmR3TEJUZ25MU1lzdC84dGxmRkRTbnVGNy9KUDVGQTRzPS0tQnRxR2xSTis1T2R2N0M0VjJiMDZxUT09--907b4f5733c3917c34d5fe9cd2101e0b0eb02ada&preview_theme_id=132772692065&redirect_source=direct_checkout_product&tracking_unique=94a3917e-8ab3-4c09-b7fb-98f7e331802e&tracking_visit=85d79ded-2e2f-4d35-8ae2-7548c03e3b18" className="w-full md:w-auto md:px-12 md:py-6 text-xl" data-id="element-94">
              SÍ, QUIERO EMPRENDER CON UNCIÓN
            </Button>

            <div className="flex items-center justify-center gap-6 text-cream/50 text-sm" data-id="element-95">
              <div className="flex items-center gap-2" data-id="element-96">
                <Lock className="w-4 h-4" data-id="element-97" />
                <span data-id="element-98">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-99">
                <ShieldCheck className="w-4 h-4" data-id="element-100" />
                <span data-id="element-101">Garantía de 7 días</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}